import React from 'react';
import lodash from 'lodash';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import BeaufortDetailedAccountModal from './BeaufortDetailedAccountModal';
import BeaufortDetailedBillModal from './BeaufortDetailedBillModal';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import AccountLinkForm from '../../../../form/AccountLinkForm';

class Beaufort extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  SELECTOR_ID = 'view.beaufort.search.selector';

  BEAUFORT = 'beaufort';

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccount, } = this.state;
    if (!selectedAccount || selectedAccount.id !== selectedRow.id) {
      const account = accountRows.find((row) => {
        const { raw, } = row;
        return raw.id === selectedRow.id;
      });

      this.setState({
        selectedAccount: account.raw,
      });
    }
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;
    const bill = billRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedBill: bill.raw,
    });
  }

  getAccounts(event) {
    this.reset();
    const { combo, search, } = event;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.BEAUFORT;

    const inclusions = value => [ 'id', 'pin', 'taxYear', 'revObjId', 'externalAccountId', ].includes(value);
    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;

        if (accounts && accounts.length > 0) {
          const proto = accounts[0];
          const formattedAccounts = ObjectUtils.filterObject(proto, inclusions);

          Object.keys(formattedAccounts.value).forEach((key) => {
            headers.push({
              value: key,
              display: lodash.startCase(key),
            });
          });

          accounts.forEach((account) => {
            const copy = {
              ...account,
            };
            copy.customerIds = ObjectUtils.formatStringAsJSONArray(copy.customerIds);
            const formattedAccount = ObjectUtils.filterObject(copy, inclusions);
            rows.push({
              value: Object.values(formattedAccount.value),
              raw: copy,
            });
          });
        }
        this.setState({ accountHeaders: headers, accountRows: rows, });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  getBills(accountId) {
    this.resetBills();
    const criteria = {};
    const headers = [];
    const rows = [];
    criteria.accountId = accountId;
    criteria.serviceOfferingId = this.BEAUFORT;

    this.setState({
      isBillLoading: true,
    });

    UtilitiesService.getBeaufortBillByAccountId(criteria)
      .then((response) => {
        const { bills, } = response.data;

        const inclusions = value => [
          'id',
          'isPaid',
          'dueDate',
          'taxYear',
          'billNumber',
          'clientBillBalance_value',
          'billBalance_value',
          'payitBillBalance_value',
        ].includes(value);

        if (bills && bills.length > 0) {
          const proto = bills[0];
          const formattedAccounts = ObjectUtils.filterObject(proto, inclusions);

          Object.keys(formattedAccounts.value).forEach((key) => {
            headers.push({
              value: key,
              display: lodash.startCase(key),
            });
          });
          bills.forEach((bill) => {
            const formattedBills = ObjectUtils.filterObject(bill, inclusions);
            rows.push({
              value: Object.values(formattedBills.value),
              raw: bill,
            });
          });
        }

        this.setState({
          billHeaders: headers,
          billRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ isBillLoading: false, });
      });
  }

  showSelectedAccountInfo = (selectedAccount) => {
    const { isBillLoading = false, } = this.state;
    if (!selectedAccount) {
      return null;
    }
    return (
      <div className="container">
        <p>{`Selected ID: ${selectedAccount.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <BeaufortDetailedAccountModal account={selectedAccount} />
          </div>
          <div className="m-1">
            <AsyncActionButton
              onClick={() => this.getBills(selectedAccount.id)}
              contents="Show Bills"
              isLoading={isBillLoading}
              variant="primary"
              loadingVariant="secondary"
            />
          </div>
          <div className="m-1">
            <AccountLinkForm
              id={selectedAccount.id}
              customerIds={selectedAccount.customerIds}
              serviceOfferingId={this.BEAUFORT}
            />
          </div>
        </div>
      </div>
    );
  };

  showSelectedBillInfo = (selectedBill) => {
    if (!selectedBill) {
      return null;
    }
    return (
      <div className="container">
        <p>{`Selected ID: ${selectedBill.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <BeaufortDetailedBillModal bill={selectedBill} />
          </div>
        </div>
      </div>
    );
  };

  reset() {
    this.resetBills();
    this.setState({
      selectedAccount: undefined,
      accountHeaders: [],
      accountRows: [],
    });
  }

  resetBills() {
    this.setState({
      selectedBill: null,
      billHeaders: [],
      billRows: [],
    });
  }

  render() {
    const {
      accountHeaders = [],
      accountRows = [],
      billHeaders = [],
      billRows = [],
      selectedAccount,
      selectedBill,
    } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getAccounts(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Tax Accounts" style={{ maxHeight: '300px', }}>
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onRowSelect={row => this.onAccountRowSelect(row)}
            />
          </FieldSet>
        </div>
        {this.showSelectedAccountInfo(selectedAccount)}
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Tax Bills" style={{ maxHeight: '300px', }}>
            <Grid
              headers={billHeaders}
              rows={billRows}
              onRowSelect={row => this.onBillRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedBillInfo(selectedBill)}
        </div>
      </div>
    );
  }
}

export default Beaufort;
